import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PermDeviceInformationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"perm_device_information"}/>
}
